import Vue from 'vue'
import App from './App.vue'
import { router } from './assets/js/helpers/router';
import Vuelidate from 'vuelidate';
import VueCurrencyInput from 'vue-currency-input';
import VueTheMask from 'vue-the-mask';
import VueScrollTo from 'vue-scrollto';
import JsonCSV from 'vue-json-csv';
import JsonExcel from 'vue-json-excel';

require('./assets/css/normalize.css');
require('./assets/css/webflow.css');
require('./assets/css/covid-19-project.webflow.css');
require('./assets/css/style.css');

Vue.use(Vuelidate);
Vue.use(VueCurrencyInput, {
  globalOptions: {
    currency: 'USD',//Otherwise it's in euros
    locale: 'en-US',//Otherwise it switches commas and decimals
    allowNegative: false
  },
});
Vue.use(VueTheMask);
Vue.use(VueScrollTo);
Vue.component('downloadCsv', JsonCSV);
Vue.component('downloadExcel', JsonExcel)

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
  el: '#app',
  template: '<App/>',
  components: { App },
  router
}).$mount('#app')

